export function timeAgo(iso) {
  const d = new Date(iso);
  const m = (Date.now() - d) / 60000;
  if (m < 1) return "agora";
  if (m < 60) return `${Math.floor(m)} min`;
  const h = m / 60;
  if (h < 24) return `${Math.floor(h)} h`;
  const days = Math.floor(h / 24);
  if (days === 1) return "ontem";
  if (days < 7) return `${days} d`;
  const sameYear = d.getFullYear() === new Date().getFullYear();
  return d.toLocaleDateString("pt-PT", sameYear ? { day: "numeric", month: "short" } : { day: "2-digit", month: "2-digit", year: "numeric" });
}

export const fullDate = (iso) => new Date(iso).toLocaleString("pt-PT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
